import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, matchPath, useParams } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import KLFooter from "../../components/KLFooter";
import KLHeader from "../../components/KLHeader";
import KLReturningOwnerToast from "../../components/KLReturningOwnerToast";
import { RootState } from "../../store";
import { usePageTransition } from "../../hooks/usePageTransition";
import { Wrapper, Container } from "./styles";

const LayoutWrapper: React.FC = () => {
  const location = useLocation();
  const { businessId: paramBusinessId } = useParams<{ businessId: string }>();
  const pageTransitionVariants = usePageTransition('slide');

  const storeBusinessId = useSelector(
    (state: RootState) => state.businesses.businessId,
  );

  const businessId = paramBusinessId || storeBusinessId;

  const hideHeader = matchPath("/:businessId", location.pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const returningOwnerRequested = Boolean(
    (location.state as { showReturningOwnerToast?: boolean } | null)
      ?.showReturningOwnerToast,
  );
  const [showReturningOwnerToast, setShowReturningOwnerToast] =
    useState(returningOwnerRequested);

  useEffect(() => {
    if (returningOwnerRequested) {
      setShowReturningOwnerToast(true);
    }
  }, [returningOwnerRequested]);

  // Create unique key for route including search params and hash
  const routeKey = location.pathname + location.search + location.hash;

  return (
    <Wrapper>
      <Container>
        {!hideHeader && <KLHeader businessId={businessId} />}
        <KLReturningOwnerToast
          show={showReturningOwnerToast}
          onDismiss={() => setShowReturningOwnerToast(false)}
        />
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={routeKey}
            variants={pageTransitionVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{ width: "100%" }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
        <KLFooter />
      </Container>
    </Wrapper>
  );
};

export default LayoutWrapper;
